<template>
  <div>
    <div class="disclaimer">
      <p>Please read this disclaimer before you use our system, then click “I Agree”</p>
    </div>
    <div class="alert-container">
      <h3>PLEASE READ</h3>
      <div class="alert-description">
        <p>This system is designed to assist pilots in planning their flights, checking weight and balance, and ensuring they remember the PAVE checklist (Pilot, Aircraft, enVironment, External Pressures).</p>
        <p>However, it is the pilot's ultimate responsibility to ensure the safety of themselves, their passengers, and others around them. As the Pilot in Command (PIC), you are responsible for the safe operation of the aircraft, adherence to all regulations, and the proper care and maintenance of the equipment you are using.</p>
        <p>This tool serves as an aid, but it does not replace your professional judgment and thorough pre-flight preparation.</p>
        <p>By clicking “I Agree” you agree to take full responsibility of the outcome of this flight and commit to following proper flight preparation procedures.</p>
      </div>
    </div>
    <div>
      <button class="primary" @click="handleAgree" :disabled="loading">
        <b-spinner
          v-if="loading"
          label="Loading..."
          variant="light"
          class="spinner-sm"
        ></b-spinner>
        I Agree 
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    toast: {
      type: Object,
      required: true,
      default: () => {}
    },
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async handleAgree() {
      try {
        this.loading = true;
        // await dispatchAPIService.create({ userId: this.$store.getUser.id, disclaimerAgreement: true })
        this.$emit('next', { flightPlanDisclaimer: true });
      } catch (error) {
        this.toast.showError('Unable to proceed');
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style>
.alert-container {
  border: 1px solid #FF0000;
  border-radius: 10px;
  padding: 5px 18px;
  background: #fef2f2;
}
.alert-container p, .alert-container h3 {
  color: #FF0000;
}
.alert-container h3 {
  font-size: 16px;
  font-weight: bold;
  line-height: 10px;
  margin-top: 16px;
}
.alert-description {
  width: 650px;
  margin-top: 20px !important;
}
.alert-description p {
  font-size: 14px;
}
</style>
